function renameObjectProps(obj, prefix) {
  const newObj = {};
  for (const propName in obj) {
    if (obj.hasOwnProperty(propName)) {
      newObj[prefix + propName] = obj[propName];
    }
  }
  return newObj;
}

export function mapStateWithPrefix(state, prefix) {
  return {
    state: state.state,
    getters: renameObjectProps(state.getters, `${prefix}/`),
    actions: renameObjectProps(state.actions, `${prefix}/`),
    mutations: state.mutations,
  };
}
